import type { Ability } from "../../rules";
import type { SpearheadArmy } from "./rules";

export const ShieldOfAzyr: Ability = { oncePerBattle: true, time: "yhp" };
export const StormCharge: Ability = { oncePerBattle: true, time: "ycp" };

export const HallowedScrolls: Ability = { time: "p" };
export const MorrdaSTalon: Ability = { time: "p" };
export const QuicksilverDraught: Ability = { oncePerBattle: true, time: "afp" };
export const NullPendant: Ability = { oncePerBattle: true, time: "eat" };

export const StrikeWhereNeeded: Ability = { oncePerBattle: true, time: "ryr" };
export const BlazeOfGlory: Ability = { oncePerBattle: true, time: "afp" };

export const StormcastEternalsVigilantBrotherhood: SpearheadArmy = {
  battleTraits:      [ShieldOfAzyr, StormCharge],
  enhancements:      [HallowedScrolls, MorrdaSTalon, QuicksilverDraught, NullPendant],
  faction:           "se",
  regimentAbilities: [StrikeWhereNeeded, BlazeOfGlory]
};
